import { RefObject, useEffect, useState } from 'react';

export function useIsVisible(ref?: RefObject<Element>, threshold: number = 1.0) {
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), {
            rootMargin: '0px',
            threshold: threshold,
        });
        if (ref && ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [ref]);

    return isIntersecting;
}
